export const SessionData = {
    subscriptionServer: "https://kinetisensesubscriptionsystem.azurewebsites.net",
    searchString:"",
    language:"0",
    videoSize:"400"
  }